import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
// import { posted } from 'shared/helpers/moment';
// import withPixelRatio from 'shared/hocs/withPixelRatio';
import { getTitleOrEmpty } from 'shared/helpers/common';
import { intlShape } from 'react-intl';
import { getNodeStringContents } from 'shared/helpers/react';
import { withTranslate } from 'shared/hocs/withTranslate';
import Link from 'shared/components/Link';
// import Discount from 'shared/components/Discount/Discount';
import { setNextSearchItemIndex } from 'shared/actions/history';
import Favourite from 'desktop/components/Favourite/Favourite';
import TransportGridDetails from 'shared/components/TransportGridDetails/TransportGridDetails';
import AgencyInfoSmall from 'desktop/components/AgencyInfoSmall/AgencyInfoSmall';
// import serviceUpperIcon from 'shared/assets/images/upper.svg';
// import COUNTRIES from 'shared/constants/json/countries.json';
import { getDefaultImageByType } from 'shared/constants/defaultImages';
import { stripMultipleSpaces } from 'shared/helpers/strings';
import { cleanArray } from 'shared/helpers/arrays';
import { generateUrl, getDealerLink } from 'shared/helpers/urls';
import SpanWithBackground from 'shared/components/SpanWithBackground/SpanWithBackground';
// import EUROBLH from 'shared/constants/euroblah';
// import euroImg from 'shared/assets/images/european-union.svg';
// import clarifyPriceIcon from 'shared/assets/images/price.svg';
// import Price from 'desktop/components/PriceBlock/Price';
// import WarrantyListing from 'shared/components/WarrantyListing/Warranty';
import { isVIP, getDrivenFromTitle } from 'shared/helpers/advert';

import AdvertLabel from 'shared/components/AdvertLabel/AdvertLabel';
import { getPriceBySlug } from 'shared/helpers/transportInfo';

// import {
//   isLeasingProposalAvailable,
//   isMicroCreditProposalAvailable,
// } from 'shared/helpers/leasing/myAuto';
import { isAnyLeasingAvailable } from 'shared/helpers/leasing/leasing';
// import ModalContainer from 'shared/components/ModalContainer/ModalContainer';

import PriceUah from 'shared/components/PriceUah/PriceUah';
import PriceUsdEuro from 'shared/components/PriceUsdEuro/PriceUsdEuro';
import withPixelRatio from 'shared/hocs/withPixelRatio';

import LeasingButtonWrapper from 'shared/components/LeasingOnlineBanner/LeasingButtonWrapper/LeasingButtonWrapper';
// import LeasingWithCalculatorButton from 'shared/components/LeasingOnlineBanner/LeasingWithCalculatorButton/LeasingWithCalculatorButton';
// import MicroCreditButton from 'shared/components/LeasingOnlineBanner/MicroCreditButton/MicroCreditButton';
import ClarifyPriceLink from 'shared/components/ClarifyPriceLink/ClarifyPriceLink';

import Thumb from '../Thumb/Thumb';
import s from './CarLeasingItem.css';

const PER_PAGE = 20;
// const euroAgencyId = [336, 7261];

class CarLeasingItem extends React.Component {
  static propTypes = {
    car: PropTypes.shape().isRequired,
    singleUpdatePackage: PropTypes.shape(),
    isPreview: PropTypes.bool,
    isProfile: PropTypes.bool,
    currentPage: PropTypes.number,
    index: PropTypes.number,
    setNextSearchItemIndex: PropTypes.func.isRequired,
    onOpenRemoveModalClick: PropTypes.func.isRequired,
    onOpenRemoveModalSupportClick: PropTypes.func.isRequired,
    setRatioImage: PropTypes.func.isRequired,
    editLink: PropTypes.string,
    width: PropTypes.number,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    t: PropTypes.func.isRequired,
    locale: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    handleSingleUpdate: PropTypes.func,
    //
    intl: intlShape.isRequired,
  };
  static defaultProps = {
    singleUpdatePackage: null,
    handleSingleUpdate: () => {},
    onOpenRemoveModalClick: () => {},
    editLink: '/',
    onOpenRemoveModalSupportClick: () => {},
    isPreview: false,
    isProfile: false,
    currentPage: null,
    index: null,
    width: 220,
    title: '',
  };

  state = {
    showLeasingDialog: false,
  };

  handleLinkClick = () => {
    const { currentPage, index } = this.props;

    if (currentPage && Number.isInteger(index)) {
      const nextIndex = (currentPage - 1) * PER_PAGE + (index + 1) + 1;
      this.props.setNextSearchItemIndex(nextIndex);
    }
  };

  toggleLeasingModal = () => {
    this.setState({ showLeasingDialog: !this.state.showLeasingDialog });
  };

  renderCarTitle = advert =>
    cleanArray([
      getTitleOrEmpty(advert.make) || advert.make_title,
      getTitleOrEmpty(advert.model) || advert.model_title,
      getTitleOrEmpty(advert.modification),
      getTitleOrEmpty(advert.equipment),
    ]).join(' ');

  render() {
    const {
      car,
      // isPreview,
      width,
      setRatioImage,
      title,
      t,
      locale,
      index,
    } = this.props;
    const {
      id,
      photos,
      driven_from: drivenFrom = {},
      date_publicated: datePublicated,
      hot_date: hotDate,
      transport,
      clarify_price_link: clarifyLink,
      is_not_cleared: isNotCleared,
    } = car;

    const agency = car.agency && car.agency.id && car.agency;

    const defaultImg = getDefaultImageByType(transport) || null;

    const agencyLogo = agency && agency.logo && agency.logo.replace('http:', 'https:');

    const abroadTitle = isNotCleared && t('нерастаможен');
    const drivenFromTitle = getDrivenFromTitle(drivenFrom, t);
    const imgAlt = title
      ? `${stripMultipleSpaces(getNodeStringContents(title))} - ${t('купить на Автобазаре')}`
      : '';

    const carTitle = this.renderCarTitle(car);
    const link = `/${generateUrl(car)}`;
    const isLeasing = isAnyLeasingAvailable(car);
    const priceTheme = isLeasing ? 'small' : 'yellow';

    return (
      <React.Fragment>
        <div
          className={cx(s.root, {
            [s.isVip]: isVIP(car),
            [s.highlight]: this.state.showLeasingDialog,
          })}
        >
          <div className={s.wrapper}>
            <div className={s.photos}>
              <Thumb
                isLazy={index >= 4}
                key={Math.random()}
                width={width}
                photos={photos}
                link={link}
                defaultImg={defaultImg}
                alt={imgAlt}
              />
              <AdvertLabel advert={car} />
            </div>
            <div className={s.conteiner}>
              <div className={s.details}>
                <div className={s.detailsLeft}>
                  <div className={s.title}>
                    {carTitle} {abroadTitle && <SpanWithBackground text={abroadTitle} />}
                    {drivenFromTitle && <SpanWithBackground text={drivenFromTitle} />}
                  </div>
                  <div className={s.technical}>
                    <TransportGridDetails advert={car} />
                  </div>
                </div>
                {!clarifyLink && (
                  <div className={s.detailsRight}>
                    {isLeasing && (
                      <LeasingButtonWrapper
                        advert={car}
                        index={index}
                        useToolTip
                        showDialog={this.state.showLeasingDialog}
                        toggleLeasingModal={this.toggleLeasingModal}
                      />
                    )}
                    <PriceUah uah={getPriceBySlug(car.price, 'uah')} theme={priceTheme} />
                    <PriceUsdEuro
                      usd={getPriceBySlug(car.price, 'usd')}
                      eur={getPriceBySlug(car.price, 'eur')}
                    />
                  </div>
                )}
                {clarifyLink && (
                  <div className={s.detailsRight}>
                    <ClarifyPriceLink link={clarifyLink} />
                  </div>
                )}
              </div>
              <div className={s.footer}>
                <div>
                  {agency && (
                    <AgencyInfoSmall
                      title={agency.title || ''}
                      link={getDealerLink(agency)}
                      src={setRatioImage(agencyLogo, 40)}
                    />
                  )}
                </div>
                <Favourite id={id} imgWidth={18} isCompact />
              </div>
            </div>
            <Link
              to={`/${generateUrl(car)}`}
              className={s.stretchedLink}
              onClick={this.handleLinkClick}
              data-lens-event={'carPageClick'}
            >
              <span />
            </Link>
          </div>
        </div>
        {this.state.showLeasingDialog && (
          <div className={s.bg} onClick={() => this.toggleLeasingModal(false)} />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ globals, user }) => ({
  locale: globals.locale,
  token: user && user.token,
});

const mapDispatchToProps = {
  setNextSearchItemIndex,
};

export default withStyles(s)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withPixelRatio(withTranslate(CarLeasingItem))),
);



// WEBPACK FOOTER //
// ./src/desktop/components/CarLeasingItem/CarLeasingItem.js